module.exports = __webpack_public_path__ + "img/hand-cursor.fcf669f1.png";